import { useCallback, useEffect, useRef, useState } from "react";
import api from "../utils/api";
import { useVisibleRefresh } from "./useVisibleRefresh";

export const LIVE_POLL_MS = 30000;

export function useLiveData(channelId) {
  const [liveValue, setLiveValue] = useState(0);
  const [serverMinuteIndex, setServerMinuteIndex] = useState(null);

  // Stops a poll that outlives its channel writing into the new one's card.
  const currentChannel = useRef(channelId);
  currentChannel.current = channelId;

  const loadLive = useCallback(async () => {
    if (!channelId) return;

    try {
      const res = await api.get(`/live?c=${channelId}`);
      if (currentChannel.current !== channelId) return;

      const data = res.data || {};
      setLiveValue(Number(data[channelId]) || 0);

      // Server-side minute index used for last-week comparison
      const minuteIdx = res.headers["x-server-minute-index"];
      if (minuteIdx != null) {
        setServerMinuteIndex(Number(minuteIdx));
      }
    } catch {
      // Keep the last good reading: zeroing turns a dropped request into
      // "nobody is watching".
      if (currentChannel.current === channelId) {
        setLiveValue((prev) => prev || 0);
      }
    }
  }, [channelId]);

  useEffect(() => {
    if (!channelId) return undefined;

    setLiveValue(0);
    loadLive();

    const timer = setInterval(loadLive, LIVE_POLL_MS);
    return () => clearInterval(timer);
  }, [channelId, loadLive]);

  useVisibleRefresh(loadLive, !!channelId);

  return { liveValue, serverMinuteIndex };
}
